import React from 'react';
import NewChart from '../NewChart';

const GoldChartHtml = () => {
    return (
        <div className="gold_chart_html_component">
            <NewChart title="gold_chart_html" defaultValue = "Gold" material = "nomaterial" />
        </div>
    )
}

export default GoldChartHtml;